import Stylus from './Stylus';
import SvgStampDrawingBrush from './SvgStampDrawingBrush';
import StampMenu from '../toolbars/StampMenu';
import stampIcon from '../assets/icons/stamp.svg';
import { svgToIcon } from '../utils/svg';
import type WhiteboardController from '../controllers/WhiteboardController';
import { ahaSvgIconString } from '../toolbars/ObjectMenu/SpriteSvg';

export type StylusSvgStampName =
  | 'aha-icon--thumbs-up'
  | 'aha-icon--thumbs-down'
  | 'aha-icon--question'
  | 'aha-icon--star'
  | 'aha-icon--slight-smile'
  | 'aha-icon--frowning'
  | 'aha-icon--smile'
  | 'aha-icon--disappointed'
  | 'aha-icon--heart-eyes'
  | 'aha-icon--confused'
  | 'aha-icon--star-struck'
  | 'aha-icon--astonished'
  | 'aha-icon--slight-smile-elle'
  | 'aha-icon--frowning-elle'
  | 'aha-icon--smile-elle'
  | 'aha-icon--disappointed-elle'
  | 'aha-icon--heart-eyes-elle'
  | 'aha-icon--confused-elle'
  | 'aha-icon--star-struck-elle'
  | 'aha-icon--astonished-elle';

interface StylusSvgStampOptions {
  svg: StylusSvgStampName;
}

// Place an emoji on the canvas.
class StylusSvgStamp extends Stylus {
  options: StylusSvgStampOptions;

  constructor({
    controller,
    options,
  }: {
    controller: WhiteboardController;
    options?: StylusSvgStampOptions;
  }) {
    super({ controller });
    this.options = options || { svg: 'aha-icon--thumbs-up' };
  }

  activate() {
    const brush = new SvgStampDrawingBrush(this.controller.canvas, this);
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  renderIcon() {
    return svgToIcon(stampIcon);
  }

  cursor() {
    return 'crosshair';
  }

  subMenu() {
    return StampMenu;
  }

  subMenuName() {
    return 'stamps';
  }

  renderEmoji() {
    if (this.options.svg) {
      return svgToIcon(ahaSvgIconString(this.options.svg), {
        fillContainer: true,
      });
    } else {
      return undefined;
    }
  }

  description() {
    return 'Stamp';
  }
}

export default StylusSvgStamp;
